<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle isPoppins">Payment Source</H1>

            <div class="limitWidth top40" id="billingInfo">
                <form class="form accSettingsForm" v-on:submit.prevent="submitForm" v-if="showForm">
                    <div class="field has-text-weight-bold is-size-5">
                        Billing Information:
                    </div>
                    <div class="field" :class="{formError: errors.first('NameOnCard') }">
                            Name on Card:*
                            <input type="text" class="input is-warning" name="NameOnCard" v-validate="'required'" v-model="form.nameOnCard"/>
                            <p class="help is-danger" >
                                {{errors.first('NameOnCard')}}
                            </p>
                        </div>
                    <div class="field" :class="{formError: errors.first('Address') }">
                        Address:*
                        <input type="text" class="input is-warning" name="Address" v-validate="'required'" v-model="form.address1" />
                        <p class="help is-danger" >
                            {{ errors.first('Address') }}
                        </p>
                    </div>
                    <div class="field">

                       <input type="text" class="input is-warning" name="Address2" v-model="form.address2" />

                    </div>
                    <div class="field" :class="{formError: errors.first('City') }">
                        City:*
                        <input type="text" class="input is-warning" name="City" v-validate="'required'" v-model="form.city"/>
                        <p class="help is-danger" >
                            {{ errors.first('City') }}
                        </p>
                    </div>
                    <div class="field" :class="{formError: errors.first('State') }">
                        State/Province:*
                        <input type="text" class="input is-warning" name="State" v-validate="'required'" v-model="form.state"/>
                        <p class="help is-danger" >
                            {{ errors.first('State') }}
                        </p>
                    </div>
                    <div class="field" :class="{formError: errors.first('PostalCode') }">
                        Postal Code:*
                        <div>{{form.zip}}</div>
                        <p class="help " >
                            Enter Postal Code below in Card Information section after entering card number
                        </p>
                    </div>
                    <div class="field" :class="{formError: errors.first('Country') }">
                        Country:*<br/>
                        <div class="select is-warning width100">
                            <select name="Country" class="width100"  v-validate="'required'" v-model="form.country">
                                <option disabled value="">Select...</option>
                                <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                            </select>
                        </div>
                        <p class="help is-danger" >
                            {{ errors.first('Country')}}
                        </p>
                    </div>

                    <div class="field has-text-weight-bold is-size-5 top40">
                        Card Information:
                    </div>

                    <div class="field" v-show="!hideExisting">
                        <label >
                        <input type="radio" name="card" value="existing"  v-model="form.prefCard" /> Existing Card ending in: *{{computedLast4}}
                        </label>
                        <br>
                        <label>
                            <input type="radio" name="card" value="alternate"  v-model="form.prefCard" id="newCardRadio" class="top20" /> Other debit or credit card:
                        </label>
                    </div>

                    <div v-show="form.prefCard == 'alternate'" >
                        
                        <div class="field">
                            Card Number, Expiration, CVC Code and Postal Code:*
                        </div>

                        <div class="has-background-light stripeCardField">
                            <div id="card-element" class="card-element-styles">
                                <!-- a Stripe Element will be inserted here. -->
                            </div>
                            <!-- Used to display Element errors -->
                            <div id="card-errors" role="alert"></div>
                        </div>
                    </div>

                    <div class="field top20">
                        <button type="submit" class="button is-warning top10" id="submitBt">SAVE</button>
                    </div>
                </form>

                <div v-if="!showForm">
                    <div class="is-size-4 has-text-dark">
                        Your payment source details have been updated.
                    </div>

                    <div class="top20">
                        <button class="button" @click="$router.push('/')">HOME</button>
                    </div>

                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import countries from '../STATIC/countries.js'
import { AZEventBus } from '../components/AZEventBus.js';

export default {
  props:{goAfter: String, payload: Object},  
  components: {
    MainLayout
  },
  data: function () {
    var form = {
      nameOnCard: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      prefCard: 'existing',
      stripeToken: '',
      inited: false
    }

    return {
      form: form,
      showForm: true,
      hideExisting: false,
      countries
      // stripe: {}
    }
  },
  mounted: function () {
    const self = this
    this.stripe = {}

    const configStripe = function () {
      self.stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY)

      var elements = self.stripe.elements()

      var style = {
        base: {
          color: '#000',
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#888'
          }
        },
        invalid: {
          color: '#e5424d',
          ':focus': {
            color: '#303238'
          }
        },
        'card-errors': {
            color: '#A00'
        }
      }

      // Create an instance of the card Element
      self.card = elements.create('card', {style: style})

      // Add an instance of the card Element into the `card-element` <div>
      self.card.mount('#card-element')

      self.card.addEventListener('change', function (event) {
        var displayError = document.getElementById('card-errors')
        if (event.error) {
          displayError.textContent = event.error.message
        } else {
          displayError.textContent = ''
        }
      })
    }

    this.$root.loadScript('https://js.stripe.com/v3/', configStripe)


/*     //az.addRemSpinner(true, 'id', 'billingInfo');
    function worked(obj){
        az.addRemSpinner(false, 'id', 'billingInfo');
    }  
    function noWorked() {
        az.addRemSpinner(false, 'id', 'billingInfo');
        self.$root.showModalOK({message: 'There was en error loading the information'})
    } */

    

    function init(){
        self.inited = true
        function processPayload(noData){
            if(noData){
                self.hideExisting = true;
                self.form.prefCard = 'alternate';
                return
            }
            
            if(self.payload.last4 != undefined){
                for(var prop in self.payload){
                    self.form[prop] = self.payload[prop]
                }
            } else {
                self.hideExisting = true;
                self.form.prefCard = 'alternate';
            }
        }
       
        if(self.payload == undefined){
            function worked(data){
                az.addRemSpinner(false, 'id', 'billingInfo');
                if(data.response == false){
                    processPayload(true);
                    return
                }
                self.payload = data
                processPayload();
            }
            function noWorked(error){
                az.addRemSpinner(false, 'id', 'billingInfo');
                self.$root.showModalOK({message: 'There was en error loading the information. Please try again.'})
                //console.log(error);
            }
            az.addRemSpinner(true, 'id', 'billingInfo');
            var cartID = az.getCookie('SlinkCartID');
            self.$root.apiClient.get('api/account/pmtMech/false', {}, worked, noWorked, null, {'cart-user-id': cartID});
        } else {
            processPayload();
        }

        
    }

    if(self.$root.doneFederating){
        init();
    }

    AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
            init();
    });
    
  },
  methods: {
    submitForm: function () {

        var self = this

        if (document.getElementById('newCardRadio').checked == true) { //means user is updating cc number, exp, sec code or zip
            var self = this
            this.stripe.createToken(this.card).then(function (result) {
            if (result.error) {
                // Inform the user if there was an error
                var errorElement = document.getElementById('card-errors')
                errorElement.textContent = result.error.message
            } else {
                self.form.stripeToken = result.token.id
                sendToBackend()
            }
            })
        } else { //user is only updating name or address
            sendToBackend()
        }

        function sendToBackend(){
            az.addRemSpinner(true, 'id', 'submitBt');
            function noWorked(){
                az.addRemSpinner(false, 'id', 'submitBt');
            }

            function worked(data){
                az.addRemSpinner(false, 'id', 'submitBt');
                window.scrollTo(0,0)

                if(data.error == 'card_declined'){
                    self.$root.showModalOK({message: 'Oops! Your card was declined, please check the information submitted.'})
                    return
                } else if (data.error == 'card_expired'){
                    self.$root.showModalOK({message: 'Oops! This card is expired, please provide a valid card.'})
                    return
                }

                if(self.goAfter != undefined){
                    self.$router.push(self.goAfter);
                } else {
                    //console.log(JSON.stringify(self.form));
                    self.showForm = false
                }
            }

            function noWorked(err){
                az.addRemSpinner(false, 'id', 'submitBt');
            }

            self.$root.apiClient.put('api/account/updatePmt', self.form, worked, noWorked); 
        }

        /* this.$validator.validateAll().then(res=>{
            if(res && ok) {

                this.showForm = false;
            } else {
                this.$root.showModalOK({message:'Please correct the errors on the form'});
            }
        }) */
    }
  },
    computed: {
        computedLast4: function(){
            if(typeof this.payload !== 'undefined'){
                if(typeof this.payload.last4 !== 'undefined'){
                    return this.payload.last4;
                } else {
                    return ''
                }
            }
            
         }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/PmtSrc.vue